import React from 'react';
import { jwtDecode } from 'jwt-decode';
import AccessControl from './AccessControl';
import { useAuth } from '../context/AuthContext';

const AttendanceList = ({ attendanceRecords = [] }) => {
  const { user, getAccessToken, isAuthenticated } = useAuth();
  const safeAttendanceRecords = Array.isArray(attendanceRecords) ? attendanceRecords : [];

  const token = getAccessToken();
  let decodedToken = null;

  if (token) {
    try {
      decodedToken = jwtDecode(token);
    } catch {
      decodedToken = null;
    }
  }

  let storedUser = null;
  try {
    storedUser = JSON.parse(localStorage.getItem('user') || 'null');
  } catch {
    storedUser = null;
  }

  const role =
    user?.role ||
    decodedToken?.role ||
    storedUser?.role ||
    null;

  const tenantType =
    user?.tenant_Type ||
    user?.tenantType ||
    user?.userData?.tenant_Type ||
    user?.userData?.tenantType ||
    decodedToken?.tenant_Type ||
    decodedToken?.tenantType ||
    storedUser?.tenant_Type ||
    storedUser?.tenantType ||
    null;

  const isRestaurantTenant = tenantType ? tenantType === 'restaurant' : true;

  const openAttendanceWindow = () => {
    window.open('/attendance-screen', '_blank', 'width=500,height=700');
  };

  const downloadCSV = (records) => {
    const convertToCSV = (records) => {
      const header = ['Employee ID', 'Name', 'Time In', 'Time Out'];
      const rows = records.map(record => [
        record.employee.employeeId,
        record.employee.name,
        new Date(record.timeIn).toLocaleString('en', { timeZone: 'Asia/Hong_Kong' }),
        record.timeOut ? new Date(record.timeOut).toLocaleString('en', { timeZone: 'Asia/Hong_Kong' }) : 'Not Yet Timed Out'
      ]);

      let csvContent = "data:text/csv;charset=utf-8," 
        + header.join(",") 
        + "\n" 
        + rows.map(row => row.join(",")).join("\n");

      return encodeURI(csvContent);
    };

    const csvData = convertToCSV(records);
    const link = document.createElement('a');
    link.setAttribute('href', csvData);
    link.setAttribute('download', 'attendance_records.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="  bg-white ">
      <h2 className="text-2xl mb-4 text-center">Today's Attendance Records</h2>

      {isRestaurantTenant && (
        <AccessControl role={role} permission="open_attendance">
          <div className="w-full flex justify-end mb-3">
            <button
              type="button"
              onClick={openAttendanceWindow}
              className="px-4 py-2 bg-teal-500 text-white rounded hover:bg-teal-600"
            >
              Open Attendance Window
            </button>
          </div>
        </AccessControl>
      )}

      {/*
      <div className='w-full text-right'>
        <button className="bg-slate-100 text-slate-900 px-4 py-2 text-right" onClick={() => downloadCSV(attendanceRecords)}>Download CSV</button>
      </div>
      */}
      
      <table className="min-w-full divide-y divide-gray-200">
        <thead>
          <tr>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Employee ID</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Name</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Time In</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Time Out</th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {safeAttendanceRecords.map(record => (
            <tr key={record._id}>
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{record.employee.employeeId}</td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{record.employee.name}</td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{new Date(record.timeIn).toLocaleString('en', { timeZone: 'Asia/Hong_Kong' })}</td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{record.timeOut ? new Date(record.timeOut).toLocaleString('en', { timeZone: 'Asia/Hong_Kong' }) : 'N/A'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AttendanceList;
